import { AppBar, Box, Button, Paper, TextField, Toolbar, Typography } from '@mui/material'
import React, { useState } from 'react'
import { Cancel, Save } from '@mui/icons-material';
import { Link, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { saveMediaResource } from '../../../actions/mediaResourceActions';
import LoadingBackdrop from '../../Common/LoadingBackdrop';
import ImageContainerPreview from '../../Common/ImageContainerPreview';
import MainContentContainer from '../../MainContentContainer/MainContentContainer';

export default function MediaResourceForm() {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const loading = useSelector(state => state.mediaResources.loading);

    const [mediaResource, setMediaResource] = useState({
        name: '',
        description: '',
        file: null
    })

    const handleChange = e => {
        setMediaResource({
            ...mediaResource,
            [e.target.name]: e.target.value
        })
    }

    const handleImageUpload = e => {
        const file = e.target.files[0];
        setMediaResource({
            ...mediaResource,
            file
        })
    }

    const handleRemove = () => {
        setMediaResource({
            ...mediaResource,
            file: null
        })
    }

    const handleSave = () => {
        dispatch(saveMediaResource(mediaResource, () => navigate('/media-resources')));
    }

    return (
        <MainContentContainer>
            <LoadingBackdrop open={loading} />
            <AppBar position="static">
                <Toolbar>
                    <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
                        Create Media Resource
                    </Typography>
                    <Button
                        color="error"
                        component={Link}
                        to="/media-resources"
                        startIcon={<Cancel />}
                        variant="contained"
                        sx={{ marginRight: 2 }}
                    >
                        Cancel
                    </Button>
                    <Button
                        color="success"
                        onClick={handleSave}
                        startIcon={<Save />}
                        variant="contained"
                    >
                        Save
                    </Button>
                </Toolbar>
            </AppBar>
            <Box gap={4}>
                <Paper sx={{ padding: 2 }}>
                    <Box sx={{ display: 'flex', gap: 3, flexDirection: { xs: 'column', md: 'row' } }}>
                        <Box sx={{ flex: 2, display: 'flex', flexDirection: 'column', gap: 2 }}>
                            <TextField
                                fullWidth
                                label="Name"
                                variant="outlined"
                                name="name"
                                value={mediaResource.name}
                                onChange={handleChange}
                                autoFocus
                                required
                            />
                            <TextField
                                fullWidth
                                label="Description"
                                variant="outlined"
                                name="description"
                                multiline
                                minRows={3}
                                value={mediaResource.description}
                                onChange={handleChange}
                                required
                            />
                        </Box>
                        <Box sx={{ flex: 1 }}>
                            <ImageContainerPreview
                                title={mediaResource.file?.name || 'Upload Media Resource'}
                                image={mediaResource.file ? URL.createObjectURL(mediaResource.file) : null}
                                name="file"
                                handleRemove={handleRemove}
                                handleImageUpload={handleImageUpload}
                                sx={{ height: 300, bgcolor: 'grey.100' }}
                            />
                        </Box>
                    </Box>
                </Paper>
            </Box>
        </MainContentContainer>
    )
}
